import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AIbanner from "../Page-section/ai-driven-marketing/AIbanner";
// import AIservice from "../Page-section/ai-driven-marketing/AIservice";
import AIprocess from "../Page-section/ai-driven-marketing/AIprocess";
import { useSEO } from "../hooks/useSEO";

function AIDrivenMarketing() {
  useSEO({
    title:
      "AI Automation Services for Faster Growth & Higher ROI",
    description:
      "Boost efficiency with ai automation services using smart AI tools, chatbots & machine learning. Automate tasks, increase ROI & scale your business faster today!",
    canonical: "https://empowerweb.in/ai-automation-services",
    ogTitle: "ai automation services, ai powered automation",
    ogDescription:
      "Transform your marketing with AI automation. Data-driven strategies for better ROI and customer engagement.",
    keywords:
      " ai automation services, ai powered automation, ai for software testing, ai chatbots for customer service",
  });
  return (
    <div>
      <Header />
      <Navbar />
      <main>
        <AIbanner />
        <AIprocess />
        {/* <AIservice /> */}
      </main>
      <Footer />
      
    </div>
  );
}

export default AIDrivenMarketing;
